export interface CopilotCloudOptions {
  baseUrl?: string;
  publicApiKey?: string;
}
